<div class="flex flex-col items-center justify-center">
  <div class="relative size-[120px]">
    <svg
      class="-rotate-90"
      width="120"
      height="120">
      <circle
        class="stroke-gray-slate-transparent"
        stroke-width="10"
        fill="transparent"
        r="52"
        cx="60"
        cy="60" />
      <circle
        class="ring_circle"
        [style.stroke]="color()"
        [style.stroke-dashoffset]="strokeDashoffset"
        stroke-width="10"
        fill="transparent"
        r="52"
        cx="60"
        cy="60" />
    </svg>
    <div
      class="font-barlow absolute inset-0 flex flex-col items-center justify-center font-extrabold text-gray-400 italic">
      <span class="text-2xl">{{ percentage() | number: '1.0-0' }}%</span>
    </div>
  </div>
</div>
